import Select from "../../Components/CommonCommponents/select/Select";
import { isEmpty } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import closeIcon from "../../Assets/Icons/closeIcon.svg";
import { Button, message } from "antd";
import CandodateService from "../../Service.js/CandidateService";
import toast from "react-hot-toast";
import AuthService from "../../Service.js/authService";

const RequiredFeildSkill = (props) => {
  const [messageApi, messageContextHolder] = message.useMessage();

  const {
    clearErrors,
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    setError,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    mode: "all",
    defaultValues: {},
  });
  const [skills, setSkills] = useState(props?.skillDetails?.results);
  const [removedSkills, setRemovedSkills] = useState([]);
  const [skillSearch, setSkillSearch] = useState();
  const [skillData, setSkillData] = useState();
  const [newSkills, setNewSkills] = useState([]);

  const fieldVisible = (name) => {
    const { fields } = props;
    let value = false;
    if (fields?.includes(name)) {
      value = true;
    }
    return value;
  };
  const removeSkill = async (id) => {
    props?.setSkillUpdate(false);
    console.log("enter remove");
    // const removedSkill = skills.find(item => item?.id === id);
    const updatedSkills = skills.filter((item) => item?.id !== id);
    setSkills(updatedSkills);
    // setRemovedSkills(prevState => [...prevState, removedSkill]);
    await CandodateService.createSkills([], [id], [])
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse);
          toast.success("Successfully Removed!");
          props?.setSkillUpdate(true);
          // props.close()
          // window.location.reload();
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Add");
      });
  };

  const handleSkillSearch = async (value) => {
    console.log("value", value);
    setSkillSearch(value);
    await AuthService.skillsDetails(skillSearch)
      .then((response) => {
        setSkillData(response.data.data);
        if (skillData?.results.length === 0) {
          setNewSkills((prevState) => [...prevState, skillSearch]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onChangeSkillType = (e, onChange) => {
    onChange(e);
  };
  console.log("testId", removedSkills);
  const onSubmit = async (data) => {
    const idsArray = data.skills.map((obj) => obj.value);
    console.log(idsArray, "datadata");

    const deletedSkillId = removedSkills?.map((i) => i.id);
    const newAddedSkills = [];
    await CandodateService.createSkills(
      idsArray,
      deletedSkillId,
      newAddedSkills
    )
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse);
          toast.success("Successfully Added!");
          props?.setEnable(true);
          props?.setRequiredFields([]);
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Add");
      });
  };
  return (
    <>
      <div className="edit_candidate_maindiv">
        {messageContextHolder}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div
            className={`form_content ${
              fieldVisible("skills") ? "block" : "hidden"
            }`}
          >
            {skills &&
              skills?.map((item, index) => {
                return (
                  <div className="rounded-3xl border border-gray-400 p-1 mx-2 px-2 mt-2 bg-[#EFF4F4]">
                    <div className="flex flex-wrap">
                      <p className="px-2 text-xs font-normal pt-1">
                        {item?.skills}
                      </p>
                      <button type="button">
                        <img
                          src={closeIcon}
                          alt="iconclose"
                          onClick={() => removeSkill(item?.id)}
                        />
                      </button>
                    </div>
                  </div>
                );
              })}
          </div>
          <div className="w-3/4">
            <div
              className={`form_content ${
                fieldVisible("skills") ? "block" : "hidden"
              }`}
            >
              <Select
                onSearch={(value) => handleSkillSearch(value)}
                name="skills"
                placeholder="Enter your area of Expertise/Specialization"
                label="Add Skills"
                control={control}
                options={skillData?.results?.map((oOption) => {
                  return {
                    value: oOption.option_id,
                    label: oOption.skill,
                  };
                })}
                onChange={onChangeSkillType}
                mode="tags"
                showSearch
                //  options={skillData}
                rules={{
                  required: fieldVisible("skills")
                    ? "This field is required"
                    : false,
                }}
                addNew={true}
                // className="h-12"
              />
              {/* <Select
                label={
                  <p>
                    Skills<span className="text-errorMain">*</span>
                  </p>
                }
                placeholder="Skills"
                options={skillsList}
                name={"skills"}
                control={control}
                showArrow={true}
                mode="multiple"
                onSearch={(e) => {
                  onSkillSearch(e);
                }}
                rules={{
                  required: fieldVisible("skills")
                    ? "This field is required"
                    : false,
                }}
              /> */}
            </div>
          </div>
          <div className="float-right mt-4">
            <Button type="primary" className="ml-4" htmlType="submit">
              Submit
            </Button>
          </div>
        </form>
      </div>
    </>
  );
};
export default RequiredFeildSkill;
